export default __webpack_public_path__ + "static/react-logo-ac6711f3eb3fa71b0e68da4e1feb24e3.png";